import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=5ecc86bf&"
import script from "./Remove.vue?vue&type=script&lang=js&"
export * from "./Remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports